"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainRegistryFetcher = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("@chain-registry/utils");
var _bfsPath = require("bfs-path");
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _chainInfo = require("./chain-info");
var fetchUrl = function fetchUrl(url) {
  return (0, _crossFetch["default"])(url).then(function (res) {
    if (res.status >= 400) {
      throw new Error('Bad response');
    }
    return res.json();
  });
};
// QUESTION: should ChainRegistryFetcher just be ChainRegistry?
var ChainRegistryFetcher = /*#__PURE__*/function () {
  function ChainRegistryFetcher() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, ChainRegistryFetcher);
    (0, _defineProperty2["default"])(this, "urls", []);
    (0, _defineProperty2["default"])(this, "_assetLists", []);
    (0, _defineProperty2["default"])(this, "_chains", []);
    (0, _defineProperty2["default"])(this, "_ibcData", []);
    (0, _defineProperty2["default"])(this, "chainInfoList", []);
    //
    if (options.chains) {
      this._chains = options.chains;
    }
    if (options.assetLists) {
      this._assetLists = options.assetLists;
    }
    if (options.ibcData) {
      this._ibcData = options.ibcData;
    }
    if (options.urls) {
      this.urls = options.urls;
    }
  }
  (0, _createClass2["default"])(ChainRegistryFetcher, [{
    key: "chains",
    get: function get() {
      return this._chains;
    }
  }, {
    key: "assetLists",
    get: function get() {
      return this._assetLists;
    }
  }, {
    key: "ibcData",
    get: function get() {
      return this._ibcData;
    }
  }, {
    key: "getChain",
    value: function getChain(chainName) {
      return this._chains.find(function (chain) {
        return chain.chain_name === chainName;
      });
    }
  }, {
    key: "getChainAssetList",
    value: function getChainAssetList(chainName) {
      return this._assetLists.find(function (list) {
        return list.chain_name === chainName;
      });
    }
  }, {
    key: "getGeneratedAssetLists",
    value: function getGeneratedAssetLists(chainName) {
      return (0, _utils.getAssetLists)(chainName, this._ibcData, this._assetLists);
    }
  }, {
    key: "getChainIbcData",
    value: function getChainIbcData(chainName) {
      return this._ibcData.filter(function (info) {
        return info.chain_1.chain_name === chainName || info.chain_2.chain_name === chainName;
      });
    }
  }, {
    key: "getChainInfo",
    value: function getChainInfo(chainName) {
      var chainInfo = this.chainInfoList.find(function (it) {
        return it.chainName === chainName;
      });
      if (!chainInfo) {
        chainInfo = new _chainInfo.ChainInfo({
          chainName: chainName,
          fetcher: this
        });
        this.chainInfoList.push(chainInfo);
      }
      return chainInfo;
    }
  }, {
    key: "upsertChain",
    value: function upsertChain(data) {
      var found = this._chains.find(function (chain) {
        return chain.chain_name === data.chain_name && chain.network_type === data.network_type;
      });
      if (!found) {
        this._chains.push(data);
        return;
      }
      this._chains = this._chains.map(function (chain) {
        if (chain.chain_name === data.chain_name && chain.network_type === data.network_type) {
          return data;
        } else {
          return chain;
        }
      });
    }
  }, {
    key: "updateAssetList",
    value: function updateAssetList(data) {
      var found = this._assetLists.find(function (list) {
        return list.chain_name === data.chain_name;
      });
      if (!found) {
        this._assetLists.push(data);
        return;
      }
      this._assetLists = this._assetLists.map(function (list) {
        if (list.chain_name === data.chain_name) {
          return data;
        } else {
          return list;
        }
      });
    }
  }, {
    key: "upsertIbcData",
    value: function upsertIbcData(data) {
      var found = this._ibcData.find(function (info) {
        return info.chain_1.chain_name === data.chain_1.chain_name && info.chain_2.chain_name === data.chain_2.chain_name;
      });
      if (!found) {
        this._ibcData.push(data);
        return;
      }
      this._ibcData = this._ibcData.map(function (info) {
        if (info.chain_1.chain_name === data.chain_1.chain_name && info.chain_2.chain_name === data.chain_2.chain_name) {
          return data;
        } else {
          return info;
        }
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!data.$schema) throw new Error('not a registered JSON schema type');
      var type = (0, _bfsPath.basename)(data.$schema, '.schema.json');
      switch (type) {
        case 'chain':
          this.upsertChain(data);
          break;
        case 'assetlist':
          this.updateAssetList(data);
          break;
        case 'ibc_data':
          this.upsertIbcData(data);
          break;
        default:
          throw new Error('unknown schema type');
      }
      this.chainInfoList.forEach(function (chainInfo) {
        chainInfo.refresh();
      });
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
        var data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchUrl(url);
            case 2:
              data = _context.sent;
              this.update(data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchUrls",
    value: function () {
      var _fetchUrls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this = this;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Promise.all(this.urls.map(function (url) {
                return _this.fetch(url);
              })));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchUrls() {
        return _fetchUrls.apply(this, arguments);
      }
      return fetchUrls;
    }()
  }]);
  return ChainRegistryFetcher;
}();
exports.ChainRegistryFetcher = ChainRegistryFetcher;